function BattleResultMessage(props: { message: string | JSX.Element }): JSX.Element {

    return <>{props.message}</>
}

export default BattleResultMessage;